import { render, staticRenderFns } from "./WorkplaceView.vue?vue&type=template&id=13ee28d5&scoped=true"
import script from "./WorkplaceView.vue?vue&type=script&lang=js"
export * from "./WorkplaceView.vue?vue&type=script&lang=js"
import style0 from "./WorkplaceView.vue?vue&type=style&index=0&id=13ee28d5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ee28d5",
  null
  
)

export default component.exports